<template>
  <v-dialog
    v-model="showForm"
    max-width="1000px"
  >
    <v-card v-if="editedItem">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Name"
                :label="$t('sysUser.name', locale)"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-select
                v-model="editedItem.Type"
                :items="types"
                :label="$t('workspace.contentType.type', locale)"
                :disabled="editedItem.ID !== null"
                item-text="name"
                item-value="value"
                outlined
                hide-details
              />
            </v-col>
            <v-col
                v-if="editedItem.Type === 'event'"
                cols="12"
                sm="12"
                md="6"
            >
                <v-select
                  :items="allMeliaIDs"
                  v-model="editedItem.EventMeliaID"
                  label="MeliaID (utilizado para mostrar events de su api)"
                  item-text="Name"
                  item-value="ID"
                  outlined
                  hide-details
                />
            </v-col>
          </v-row>
          <v-row
            v-if="editedItem.Type === 'activityBarcelo01'"
          >
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Ab01MeteoID"
                label="MeteoID (Santa_Cruz)"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Ab01QRURL"
                label="QR URL"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Ab01RomanticClientID"
                label="Romantic (clientID)"
                hide-details
              />
            </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <v-select
        v-model="editedItem.Ab01ActtivID"
        :items="[{ID: null, Name: ''},...acttiv]"
        label="Acttiv.... [opcional]"
        outlined
        hide-details
        itemText="Name"
        itemValue="ID"
      />
    </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <v-select
                v-model="editedItem.Ab01ActivePlans"
                :items="plans"
                label="Planes activos"
                outlined
                multiple
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <v-checkbox
                v-model="editedItem.Ab01ISBarcyComplementaryPlans"
                label="Barcy planes complementarios"
                outlined
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="editedItem.Ab01ISEntertainers"
                label="Animadores"
                outlined
                hide-details
              />
            </v-col>
            <v-col
              v-if="editedItem.ID"
              cols="12"
              sm="6"
              style="padding: 40px 20px 0 0;"
            >
              <AB01PlacesForm
                :locale="locale"
                :id="editedItem.ID"
                :workspaceID="workspaceID"
              />
            </v-col>
            <v-col
              v-if="editedItem.ID"
              cols="12"
              sm="12"
              md="6"
            >
              <v-select
                v-model="editedItem.Ab01BrandID"
                :items="ab01brands"
                label="Marca"
                item-text="Name"
                item-value="ID"
                outlined
                hide-details
              />
            </v-col>
            <v-col
              v-if="editedItem.ID"
              cols="12"
              sm="12"
              md="6"
            >
              <v-select
                v-model="editedItem.Ab01AreaID"
                :items="ab01areas"
                label="Área"
                item-text="Name"
                item-value="ID"
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            v-if="isWithSize"
          >
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Width"
                :label="$t('workspace.contentType.width', locale)"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Height"
                :label="$t('workspace.contentType.height', locale)"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            v-if="isContainsImage"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="editedItem.AllowedTypes"
                :items="allowedTypes"
                :label="$t('workspace.contentType.allowedTypes', locale)"
                multiple
                item-text="name"
                item-value="value"
                chips
              />
            </v-col>
          </v-row>
          <v-row
            v-if="editedItem.Type === 'audio'"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-switch
                v-model="editedItem.BySequence"
                :label="$t('workspace.contentType.bySequence', locale)"
                color="primary"
                hide-details
              />
            </v-col>
          </v-row>
          <event-config
            v-if="editedItem.Type === 'event'"
            :id="editedItem.ID"
            :eventConfig="editedItem.EventConfig"
            :onChange="handleUpdateEventConfig"
            :locale="locale"
            :workspaceID="workspaceID"
            :languages="languages"
            :eventMeliaID="editedItem.EventMeliaID"
          />
          <weekly-menu-config
            v-if="editedItem.Type === 'weeklyMenu'"
            :editedItem="editedItem"
            :onChange="handleUpdateWeeklyMenuConfig"
            :locale="locale"
            :workspaceID="workspaceID"
          />
          <meeting-room-config
            v-if="editedItem.Type === 'meetingRoom'"
            :editedItem="editedItem"
            :onChange="handleUpdateMeetingRoomConfig"
            :locale="locale"
            :workspaceID="workspaceID"
          />
          <activity-barcelo-config
            v-if="editedItem.Type === 'activityBarcelo'"
            :editedID="editedItem.ID"
            :onChange="handleUpdateActivityBarceloConfig"
            :locale="locale"
            :workspaceID="workspaceID"
          />
          <!--v-row
            v-if="editedItem.Type === 'weeklyMenu'"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-btn
                color="primary"
                @click="handleAddWeeklyMenuItem"
              >
                {{ $t('common.add', locale) }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              :key="editedItem.WeeklyMenuConfig"
            >
              {{editedItem}}
            </v-col>
          </v-row-->
        </v-container>
      </v-card-text>
      <div style="padding: 0 25px 10px 25px;">
      <action-buttons
        :id="`${editedItem.ID}${editedItem.tmpNewItemID ? editedItem.tmpNewItemID : ''}`"
        :onDeleteItem="onDelete"
        :onSaveItem="handleSave"
        :onClose="handleClose"
        :locale="locale"
      />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import constants from '@/constants'
  import axios from 'axios'
  import api from '@/services/api'
  //import utils from '@/services/utils'
  import ActionButtons from '@/components/ActionButtons'
  import WeeklyMenuConfig from './weeklyMenuConfig/Index'
  import MeetingRoomConfig from './meetingRoomConfig/Index'
  import ActivityBarceloConfig from './activityBarceloConfig/Index'
  import EventConfig from './eventConfig/Index'
  import AB01PlacesForm from './AB01PlacesForm'
  export default {
    name: 'ContentTypeForm',
    components: {
      ActionButtons,
      WeeklyMenuConfig,
      MeetingRoomConfig,
      ActivityBarceloConfig,
      EventConfig,
      AB01PlacesForm,
    },
    props: {
      workspaceID: {
        type: String,
        required: true,
      },
      data: {
        type: Object,
        default: null
      },
      languages: {
        type: Array,
        default: null,
      },
      showForm: {
        type: Boolean,
        default: false
      },
      onChangeContentType: {
        type: Function,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      },
      onDelete: {
        type: Function,
        required: true
      },
    },
    data: () => ({
      allowedTypes: [],
      formTitle: '',
      editedItem: null,
      isWithSize: false,
      isContainsImage: false,
      ab01areas: null,
      ab01brands: null,
      acttiv: [],
      allMeliaIDs: null,
    }),
    computed: {
      ...mapState('app',['locale']),
      plans () {
        return['we', 'live-stage', 'barcy-club', 'max', 'one', 'pro']
      },
      types () {
        return constants.dviewcontentTypes
      },
      /*
      allMeliaIDs() {
        return [
          {
            id: null,
            name: ''
          },
          {
            id: '3833',
            name: 'Gran Meliá Palacio de Isora'
          }
        ]
      }
      */
      /*
      allowedTypes () {
        return constants.dviewcontentAllowedTypes
      },*/
    },
    watch: {
      'editedItem.Type' (v) {
        const aux = constants.dviewcontentTypes.filter(x => x.value===v)
        this.isWithSize = aux.length > 0 && aux[0].withSize === true
        this.isContainsImage = aux.length > 0 && aux[0].containsImage === true
        this.handleAb01Const()
      },
      data (v) {
        if (v.Ab01ActivePlans && typeof v.Ab01ActivePlans === 'string') v.Ab01ActivePlans = JSON.parse(v.Ab01ActivePlans)
        this.editedItem = v
      },
    },
  mounted() {
      this.handleGetMeliaIDs()
      this.handleAb01Const()
      this.handleGetAllowedTypes()
    },
    methods: {
      async handleGetMeliaIDs() {
        try {
          this.allMeliaIDs = await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', 'v1/system/melia/hotels')
            .then(response => {
              response.unshift(          {
                ID: null,
                Name: ''
              })
              resolve(response)
            })
            .catch (err => {
              reject(err)
            })
            .finally(() => {
            }))
        } catch (error) {
          console.log(error)
        }
      },
      async handleAb01Const () {
        try {
          this.acttiv = await new Promise((resolve, reject) => axios.get('https://acttiv-api.dtouchwebapp.com/v1/public/hotels')
            .then(response => {
              resolve(response.data)
            })
            .catch (err => {
              reject(err)
            }))
          this.ab01areas = []
          this.ab01brands = []
          if (!this.editedItem || this.editedItem.Type !== 'activityBarcelo01') return
          api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/areas/')
            .then(response => {
              this.ab01areas = response
            })
            .catch (err => {
              console.log(err)
            })
          api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/brands/')
            .then(response => {
              this.ab01brands = response
            })
            .catch (err => {
              console.log(err)
            })
        } catch (error) {
          console.log(error)
        }
      },
      handleGetAllowedTypes () {
        if (!this.workspaceID) return
        api.getAllWithoutLimit ('dviewcontent', `v1/system/workspaces/${this.workspaceID}/custom-content-types`)
          .then(response => {
            const aux = JSON.parse(JSON.stringify(constants.dviewcontentAllowedTypes)).map(item => {
              return {
                name: item,
                value: item
              }
            })
            aux.push(...response.map(item => {
              return {
                value: item.ID,
                name: item.Name,
              }
            }))

            this.allowedTypes = aux
          })
          .catch(error => {
            alert(error)
          })
      },
      handleSave() {
        this.onChangeContentType(this.editedItem)
      },
      handleClose () {
        this.onClose()
      },
      handleUpdateWeeklyMenuConfig (v) {
        this.editedItem.WeeklyMenuConfig = v
      },
      handleUpdateMeetingRoomConfig (v) {
        this.editedItem.MeetingRoomConfig = v
      },
      handleUpdateActivityBarceloConfig (v) {
        this.editedItem.ActivityBarceloConfig = v
      },
      handleUpdateEventConfig (v) {
        this.editedItem.EventConfig = v
      },
    },
  }
</script>
